import { PRODUCT_REGISTRY } from "./registry";

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const toPrefixRegex = (prefix) => {
  const normalized = prefix.replace(/\/+$/, "") || "/";
  const escaped = escapeRegExp(normalized).replace(/:[^/]+/g, "[^/]+");

  if (normalized === "/") return /^\/$/;
  return new RegExp(`^${escaped}(?:$|/)`);
};

const prefixMatchers = PRODUCT_REGISTRY.flatMap((product) =>
  product.routePrefixes.map((prefix) => ({
    productId: product.id,
    regex: toPrefixRegex(prefix),
  }))
);

export const getProductIdForPath = (pathname) => {
  const match = prefixMatchers.find(({ regex }) => regex.test(pathname));
  return match ? match.productId : null;
};
